<template>
  <footer class="column-me center-all" :class="{'mobile-mode': isMobile}">
    <div class="footer-content column-me">
      <!-- 主要内容区 -->
      <div class="pT25 pB40 w100Per">
        <div class="row-me flex-sb footer-top">
          <div class="column-me logo-section">
            <img src="../assets/img/logo.png" class="img-logo" draggable="false">
            <div class="row-me row-center pointer mT40 social-icons">
              <img src="../assets/img/home/wechat.png" class="img20 objScaleDown mR20" draggable="false"
                   @click="showWechatQrcode">
              <img src="../assets/img/home/msg.png" class="img20 objScaleDown mR20" draggable="false"
                   @click="showEmailDialog">
              <!--<img src="../assets/img/home/in.png" class="img20 objScaleDown mR20" draggable="false">-->
            </div>
          </div>
          <!-- 导航链接 - 仅PC端显示 -->
          <div class="row-me font-m mT10" v-if="!isMobile">
            <div class="row-me" v-for="(item,index) in navArray" :key="index">
              <div class="column-me" :class="{'w60 alignJ':item.title==='首页'}">
                <div class="nav-title mB10" :class="{'w100':nowLanguage==='es'||nowLanguage==='fr'}"
                     @click="clickPath(item.path)">
                  {{ item.title }}
                </div>
                <div class="nav-sub-item mT10" v-for="(subItem,subIndex) in item.children" :key="subIndex"
                     :class="{'w100':nowLanguage==='es'||nowLanguage==='fr','w70':nowLanguage==='zh-cn',
                     'w120':nowLanguage==='en'}"
                     @click="clickPath(subItem.path)">
                  {{ subItem.title }}
                </div>
              </div>
              <div class="line-menu" :class="nowLanguage==='zh-cn'?'mLR30':'mLR10'"
                   v-if="index!==navArray.length-1"></div>
            </div>
          </div>
        </div>
        <!-- Logo和公司信息 -->
        <div class="row-me flex-end2 flex-sb company-section" v-if="!isMobile">
          <div class="company-name mT30 font-l">
            {{ $t('footer.companyName') }}<br>
            {{ $t('footer.companyNameEn') }}<br>
            {{ $t('footer.address') }}<br>
            {{ $t('footer.copyright') }}<br>
            {{ $t('footer.icp') }}{{ $t('footer.icpNumber') }}&emsp;
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11011502039384" rel="noreferrer"
               target="_blank" class="police-link">
              <img src="../assets/img/an.png" class="police-icon" draggable="false">
              <span>{{ $t('footer.securityNumber') }}</span>
            </a>
          </div>
          <img src="../assets/img/home/yuewei.png" class="w180 objScaleDown yuewei-logo" draggable="false">
        </div>
        <div class="company-name mT50 font-l" v-if="isMobile">
          {{ $t('footer.companyName') }}<br>
          {{ $t('footer.companyNameEn') }}<br>
          {{ $t('footer.addressShort') }}<br><br>
          {{ $t('footer.copyright') }}<br>
          <div class="row-me row-center">
            <div>{{ $t('footer.icp') }}</div>
            <div>{{ $t('footer.icpNumber') }}&emsp;</div>
            <div>
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11011502039384" rel="noreferrer"
                 target="_blank" class="police-link police-link-mobile">
                <img src="../assets/img/an.png" class="police-icon police-icon-mobile" draggable="false">
                <span>{{ $t('footer.securityNumber') }}</span>
              </a>
            </div>
          </div>
        </div>
        <div class="row-me flex-end1 mT60" v-if="isMobile">
          <img src="../assets/img/home/yuewei.png" class="w180 objFitCover yuewei-logo" draggable="false">
        </div>
      </div>
    </div>
  </footer>
  <!-- 微信二维码弹窗 -->
  <el-dialog v-model="wechatDialogVisible" :width="isMobile ? '80%' : '320px'" center
             custom-class="wechat-qrcode-dialog">
    <template #header>
      <div class="dialog-title" :class="{'dialog-title-mobile': isMobile}">{{ $t('common.wechatQrcode') }}</div>
    </template>
    <div class="qrcode-container" :class="{'qrcode-container-mobile': isMobile}">
      <img src="../assets/img/code.png" class="qrcode-img" :class="{'qrcode-img-mobile': isMobile}" draggable="false">
    </div>
  </el-dialog>
  <!-- 邮箱弹窗 -->
  <el-dialog v-model="emailDialogVisible" :width="isMobile ? '80%' : '320px'" center
             custom-class="wechat-qrcode-dialog">
    <template #header>
      <div class="dialog-title" :class="{'dialog-title-mobile': isMobile}">{{
          $t('common.emailAddress') || '邮箱地址'
        }}
      </div>
    </template>
    <div class="email-container" :class="{'email-container-mobile': isMobile}">
      <div class="email-text" :class="{'email-text-mobile': isMobile}">{{ emailAddress }}</div>
      <div class="copy-btn" :class="{'copy-btn-mobile': isMobile}" @click="copyEmail">{{
          $t('common.copy') || '复制'
        }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {Message, Phone, Position} from "@element-plus/icons";
import {deviceState} from "@/utils/device";
import {getArticleCategories, getProductCategories} from "@/http/api";
import bus from "@/assets/js/bus";
import {getLanguage} from "../i18n";

export default {
  components: {
    Message,
    Phone,
    Position
  },
  data() {
    return {
      deviceState, // 引用全局设备状态
      wechatDialogVisible: false, // 微信二维码弹窗显示状态
      emailDialogVisible: false, // 邮箱弹窗显示状态
      emailAddress: 'info@bjywmedical.com', // 邮箱地址
      // API分类数据
      productCategories: [], // 产品分类
      academicCategories: [], // 学术资讯分类
      newsCategories: [], // 企业动态分类
      nowLanguage: '',
    }
  },
  computed: {
    // 从全局状态获取是否为移动端
    isMobile() {
      return this.deviceState.isMobile
    },
    // 导航数组 - 使用计算属性以支持动态语言切换和API数据
    navArray() {
      // 产品分类子菜单 - 从API获取
      const productChildren = this.productCategories.map((item, index) => ({
        title: item.name,
        path: `/products?tab=${index}`
      }))
      // 学术资讯分类子菜单 - 从API获取
      const academicChildren = this.academicCategories.map((item) => ({
        title: item.name,
        path: `/academic?categoryId=${item.id}`
      }))
      // 企业动态分类子菜单 - 从API获取
      const newsChildren = this.newsCategories.map((item) => ({
        title: item.name,
        path: `/news?categoryId=${item.id}`
      }))

      return [{
        title: this.$t('nav.home'),
        path: '/home',
        children: []
      }, {
        title: this.$t('nav.aboutUs'),
        path: '/aboutUs',
        children: [{
          title: this.$t('nav.companyIntro'),
          path: '/aboutUs'
        }, {
          title: this.$t('nav.awardsHonors'),
          path: '/prize'
        }]
      }, {
        title: this.$t('nav.products'),
        path: '/products',
        children: productChildren
      }, {
        title: this.$t('nav.academic'),
        path: '/academic',
        children: academicChildren
      }, {
        title: this.$t('nav.news'),
        path: '/news',
        children: newsChildren
      }, {
        title: this.$t('nav.contactUs'),
        path: '/contact',
        children: []
      }]
    }
  },
  created() {
    this.nowLanguage = getLanguage()
    // 加载分类数据
    this.loadCategories()
    // 监听语言切换事件，重新加载分类数据
    bus.$on('language-changed', this.onLanguageChanged)
  },
  mounted() {
  },
  beforeUnmount() {
    // 移除语言切换事件监听
    bus.$off('language-changed', this.onLanguageChanged)
  },
  methods: {
    // 语言切换时重新加载分类数据
    onLanguageChanged() {
      this.nowLanguage = getLanguage()
      this.loadCategories()
    },
    // 加载分类数据
    async loadCategories() {
      try {
        const [productRes, academicRes, newsRes] = await Promise.all([
          getProductCategories(),
          getArticleCategories(1), // 学术资讯
          getArticleCategories(2)  // 企业动态
        ])
        // 处理产品分类
        if (productRes && productRes.code === 200 && productRes.data) {
          this.productCategories = productRes.data.map(item => ({
            id: item.id,
            name: item.name
          }))
        }
        // 处理学术资讯分类
        if (academicRes && academicRes.code === 200 && academicRes.data) {
          this.academicCategories = academicRes.data.map(item => ({
            id: item.id,
            name: item.name
          }))
        }
        // 处理企业动态分类
        if (newsRes && newsRes.code === 200 && newsRes.data) {
          this.newsCategories = newsRes.data.map(item => ({
            id: item.id,
            name: item.name
          }))
        }
      } catch (error) {
        console.error('加载导航分类数据失败:', error)
      }
    },
    //路由跳转
    clickPath(path) {
      // 解析路径和查询参数
      if (path.includes('?')) {
        const [pathPart, queryString] = path.split('?')
        const query = {}
        queryString.split('&').forEach(param => {
          const [key, value] = param.split('=')
          query[key] = value
        })
        this.$router.push({
          path: pathPart,
          query: query
        })
      } else {
        this.$router.push({
          path: path,
          query: {}
        })
      }
      // 注意：滚动行为由全局路由守卫和各页面的路由watch处理
    },
    //外链跳转
    clickLink(link) {
      window.open(link, '_blank')
    },
    // 显示微信二维码弹窗
    showWechatQrcode() {
      this.wechatDialogVisible = true
    },
    // 显示邮箱弹窗
    showEmailDialog() {
      this.emailDialogVisible = true
    },
    // 复制邮箱地址
    copyEmail() {
      const successMsg = this.$t('common.copySuccess') || '复制成功'
      const text = this.emailAddress
      // 使用传统方式复制，兼容性更好
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      textarea.style.top = '-9999px'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success(successMsg)
        } else {
          // 尝试使用clipboard API
          navigator.clipboard.writeText(text).then(() => {
            this.$message.success(successMsg)
          }).catch(() => {
            this.$message.error('复制失败')
          })
        }
      } catch (err) {
        // 尝试使用clipboard API
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(successMsg)
        }).catch(() => {
          this.$message.error('复制失败')
        })
      }
      document.body.removeChild(textarea)
    },
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
footer {
  background: #013D5C;
  color: #FFFFFF;
  padding: 0;

  .footer-content {
    width: 1000px;
    max-width: 100%;
  }

  // 窄屏模式 - 只调整宽度，保持原布局
  &.mobile-mode {
    .footer-content {
      width: 100%;
      padding: 35px 5% 0 5%;
      box-sizing: border-box;
    }

    .img-logo {
      width: 130px;
    }

    .social-icons {
      margin-top: 50px;
    }

    .company-name {
      font-size: 22px !important;
      line-height: 1.7;
    }

    .yuewei-logo {
      width: 220px;
      height: 80px;
    }

    .img20 {
      width: 40px;
      height: 40px;
      object-fit: contain;
      margin-right: 40px;
    }
  }

  .img-logo {
    width: 130px;
    object-fit: scale-down;
    filter: brightness(0) invert(1);
  }

  .company-name {
    font-size: 12px;
    color: #FFFFFF;
    line-height: 20px;
    word-break: keep-all;
  }

  .company-desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 24px;
  }

  .nav-title {
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    user-select: none;
    //white-space: nowrap;

    &:hover {
      color: #EA8063;
    }
  }

  .nav-sub-item {
    font-size: 12px;
    color: #FFFFFF;
    cursor: pointer;
    user-select: none;

    &:hover {
      color: #EA8063;
    }
  }

  .social-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &:hover {
      background: #EA8063;
    }
  }

  .divider-line {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
  }

  .copyright-text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
  }

  .copyright-divider {
    width: 1px;
    height: 14px;
    background: rgba(255, 255, 255, 0.3);
    margin: 0 20px;
  }

  .line-menu {
    width: 1px;
    height: 15px;
    background: #FFFFFF;
    margin-top: 4px;
  }

  // 公安备案链接样式
  .police-link {
    display: inline-flex;
    align-items: center;
    color: #FFFFFF;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #EA8063;
    }
  }

  .police-icon {
    width: 14px;
    height: 14px;
    object-fit: contain;
    margin-right: 4px;
  }

  // 移动端公安备案样式
  .police-link-mobile {
    margin-top: 5px;
    font-size: 22px;
  }

  .police-icon-mobile {
    width: 22px;
    height: 22px;
    margin-right: 6px;
  }
}

// 微信二维码弹窗样式
.dialog-title {
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  letter-spacing: 2px;

  &.dialog-title-mobile {
    font-size: 25px;
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  &.qrcode-container-mobile {
    padding: 30px 20px 40px;
  }
}

.qrcode-img {
  width: 200px;
  height: 200px;
  object-fit: contain;

  &.qrcode-img-mobile {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 1;
    // 允许长按保存图片
    -webkit-touch-callout: default;
    -webkit-user-select: auto;
    user-select: auto;
  }
}

// 邮箱弹窗样式
.email-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  &.email-container-mobile {
    padding: 30px 20px 40px;
  }
}

.email-text {
  font-size: 16px;
  color: #2C2B30;
  text-align: center;
  word-break: break-all;
  padding: 20px;
  background: #F5F5F5;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;

  &.email-text-mobile {
    font-size: 24px;
    padding: 25px;
  }
}

.copy-btn {
  margin-top: 20px;
  padding: 10px 40px;
  font-size: 16px;
  color: #FFFFFF;
  background: #013D5C;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #025A87;
  }

  &:active {
    background: #012A40;
  }

  &.copy-btn-mobile {
    font-size: 24px;
    padding: 15px 60px;
    margin-top: 30px;
  }
}

</style>
